"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorNotification = void 0;
var _addToBasketFailed = require("@ori-events/add-to-basket-failed");
var _showErrorNotification = require("@ori-events/show-error-notification");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../hooks/useTranslations");
var _types = require("../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_TIMEOUT_DELAY = 3000;
const ErrorNotification = () => {
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const genericErrorFormatted = formatMessage('genericError');
  const [message, setMessage] = (0, _react.useState)(genericErrorFormatted);
  const handleClose = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const handleShowErrorNotification = event => {
    const {
      message: errorMessage
    } = event.detail;
    const formattedMessage = errorMessage != null ? formatMessage(errorMessage) : genericErrorFormatted;
    setMessage(formattedMessage);
    setIsOpen(true);
  };
  const handleAddToBasketFailed = event => {
    const {
      localizedMessage
    } = event.detail;
    setMessage(localizedMessage);
    setIsOpen(true);
  };
  (0, _react.useEffect)(() => {
    window.addEventListener(_showErrorNotification.Name, handleShowErrorNotification);
    window.addEventListener(_addToBasketFailed.Name, handleAddToBasketFailed);
    return () => {
      window.removeEventListener(_showErrorNotification.Name, handleShowErrorNotification);
      window.removeEventListener(_addToBasketFailed.Name, handleAddToBasketFailed);
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SnackbarError, {
    "data-testid": getTestId(_types.TestId.ErrorNotification),
    open: isOpen,
    message: message,
    autoHideDuration: DEFAULT_TIMEOUT_DELAY,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    onClose: handleClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Alert, {
      severity: "error",
      variant: "filled",
      children: message
    })
  }, "error");
};
exports.ErrorNotification = ErrorNotification;